export default __webpack_public_path__ + "d4487a8ac0c2e4a9b4c7e8db55866aa7.svg";